export const COLORS = {
  CYAN: "#84cfcb",
  CYAN_DARK: "#75bfbb",
  CYAN_LIGHT: "#DCF5F4",
  CYAN_20: "rgba(132, 207, 203, 0.2)",
  CYAN_LIGHT_20: "rgba(220, 245, 244, 0.2)",
  FONT_DARK: "#1A3635",
  WHITE: "#ffffff",
  BLACK: "#000000",
  BLACK_4: "rgba(0, 0, 0, 0.04)",
  BLACK_25: "rgba(0, 0, 0, 0.25)",
  BLACK_50: "rgba(0, 0, 0, 0.5)",
  WHITE_20: "rgba(255, 255, 255, 0.2)",
  WHITE_40: "rgba(255, 255, 255, 0.4)",
  BACKGROUND: "#F3F3F3",
  BACKGROUND_SIDEBAR: "#363740",
  RED: "#FF7C6F",
  RED_DARK: "#B00020",
  LAVENDER: "#7775BF",
  LAVENDER_20: "rgba(119, 117, 191, 0.2)",
  PURPLE: "#BE75BF",
  PURPLE_20: "rgba(190, 117, 191, 0.2)",
  GREY: "#DADADA",
  GREY_40: "rgba(218, 218, 218, 0.4)",
};

export const appPrimaryColor = {
  main: COLORS.CYAN,
  dark: COLORS.CYAN_DARK,
  contrastText: COLORS.WHITE,
};

export const appSecondaryColor = {
  main: COLORS.BLACK_50,
};
